// Sticky mobile CTA for landing pages. No dependencies, no libraries.
// Shows the bar once the hero has scrolled out of view; dismissible.
(function () {
  var bar = document.querySelector('[data-lp-sticky-cta]');
  var hero = document.querySelector('[data-lp-hero]');
  if (!bar || !hero) return;

  var dismissed = false;
  var dismissBtn = bar.querySelector('[data-lp-sticky-dismiss]');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', function () {
      dismissed = true;
      bar.classList.remove('is-visible');
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var heroVisible = entries[0].isIntersecting;
        if (!dismissed) {
          bar.classList.toggle('is-visible', !heroVisible);
        }
      },
      { rootMargin: '0px' }
    );
    observer.observe(hero);
  }
})();
